import { observer } from 'mobx-react-lite';
import { Box, Grid2 } from '@mui/material';

import SupportedRegions from '../../components/SupportedRegions';
import FreeTrialPlan from '../../features/freeTrialPlan/components/FreeTrialPlan';
import MonthlyPlanPlan from '../../features/monthlyPlan/components/MonthlyPlan';
import AnnualPlan from '../../features/annualPlan/components/AnnualPlan';
import EnterprisePlan from '../../features/enterprisePlan';
import PageHeader from '../../components/PageHeader';
import OverflowLoader from '../../../shared/components/OverflowLoader';
import rootStore from '../../features/rootStore/RootStore';

const PlanSelect = observer(() => {
  const { userStore } = rootStore;
  const showLoader = userStore.freeTrial.inProgress;

  return (
    <Box
      sx={{
        maxWidth: { xs: '900px', lg: '1450px' },
      }}
    >
      <PageHeader />
      <Grid2
        container
        spacing={3}
        sx={{
          justifyContent: 'center',
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'center', sm: 'stretch' },
        }}
      >
        <FreeTrialPlan />
        <MonthlyPlanPlan />
        <AnnualPlan />
        <EnterprisePlan />
      </Grid2>
      <SupportedRegions />
      {showLoader && <OverflowLoader />}
    </Box>
  );
});

export default PlanSelect;
